import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { Flex, Padding } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { mixpanel } from '@/mixpanel'
import { useLoggedInForMandatee } from '@/modules/trust/hooks/useLoggedInForMandatee'
import { StButtonContainer } from '../../pages/document-detail/SignableDocumentDetail.styled'

type Props = {
  id: number
  actorIsLegalAge: boolean
}

export const SignableDocumentStartSignButton = ({ id, actorIsLegalAge }: Props) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isLoggedInForMandatee = useLoggedInForMandatee()

  return (
    <StButtonContainer>
      {actorIsLegalAge ? null : (
        <Padding pb={theme.UI.Spacing.Space3}>
          <Span type='BodySmallRegular' color={theme.Colors.Neutrals.Dark} textAlign='center'>
            {t({
              message:
                'Je moet minstens 18 jaar zijn om dit document te ondertekenen. Iemand met volmacht kan dit voor je  doen.',
            })}
          </Span>
        </Padding>
      )}
      <Button
        disabled={!actorIsLegalAge}
        variant='Primary'
        onClick={() => {
          mixpanel.track('document_signing_start', {
            is_mandate: isLoggedInForMandatee,
          })
          navigate(`/sign/${id}`)
        }}
      >
        <Flex justifyContent='center' alignItems='center' gap={theme.UI.Spacing.Space3}>
          <FontAwesomeIcon icon={['fal', 'signature']} />
          {t({
            message: 'Start met ondertekenen',
          })}
        </Flex>
      </Button>
    </StButtonContainer>
  )
}
